import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteSmokerRateOverrideRule } from '../../../api/plan-smoker-rate-override-rules-api'
import { SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanSmokerRateOverride/hooks/useGetSmokerRateOverrideRules'

export function useDeleteSmokerRateOverrideRule() {
  const queryClient = useQueryClient()

  return useMutation<void, unknown, string>({
    mutationFn: (id) => deleteSmokerRateOverrideRule(id),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
